import { useCustomerStore } from '@/js/stores/customerStore'
import { MARKET_SEGMENTS } from '@rogue/universal'
import type { IRogue } from '@/js/services/RogueTypes'

export type CustomerTrack = {
  loggedIn: boolean

  // App Context variables
  appVersion?: string
  appPlatform?: string,
  deviceId?: string

  // Logged in traits
  _id?: string
  groupId?: string | number,
  email?: string,
  phone?: string,
  segments?: string[]
  primarySegment?: string
  loading?: boolean
  address?: {
    country: string,
    state: string
  },
}

export function getCustomerTrackData(rogue: IRogue): CustomerTrack {
  const customerStore = useCustomerStore(rogue.pinia)

  if (customerStore.loading) {
    return { loggedIn: false, loading: true }
  }

  const appContext = rogue.appContext
  const retval:CustomerTrack = {
    loggedIn : Boolean(customerStore.groupId && customerStore.groupId !== 0),
    groupId  : customerStore.groupId,
  }

  if (appContext) {
    retval.appVersion = appContext.version
    retval.appPlatform = appContext.platform
    retval.deviceId = appContext.deviceUid
  }

  if (customerStore._id) {
    retval._id = `${customerStore._id}`
    retval.email = customerStore.email || ''
    retval.phone = customerStore.telephone || ''
    retval.segments = customerStore.segments
      .map((s: string | number) => (typeof s === 'string'
        ? s
        : Object.keys(MARKET_SEGMENTS[rogue.site.id].Interests).find(key => MARKET_SEGMENTS[rogue.site.id].Interests[key] === s) || ''
      ))
      .filter((s:string) => !!s)
    retval.primarySegment = customerStore.primarySegment

    const defaultShip = customerStore.defaultShippingAddress || ''
    if (defaultShip) {
      retval.address = { country: defaultShip.countryId, state: defaultShip.region }
    }
  }

  return retval
}
